import { Button, Image } from "@atoms";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";

export type ConfirmPageTemplateProps = {
  handleBackButtonClick: () => void;
  handleResendEmailClick: () => void;
};

export const ConfirmPageTemplate = ({
  handleBackButtonClick,
  handleResendEmailClick,
}: ConfirmPageTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex">
      <AuthSection />

      {/* Right side - Confirm content */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 flex flex-col items-center">
          {/* Title */}
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {t("auth.confirmEmail.title")}
            </h1>
          </div>
          <h3 className="text-base text-gray-500 text-center mb-6">
          {t("auth.confirmEmail.instructions")}
          </h3>
          <div className="flex flex-col justify-center items-center mb-6">
            <span className="text-base text-gray-500 mr-2">
              {t("auth.confirmEmail.noEmail")}
            </span>
            <Button
              variant="link"
              label={t("auth.confirmEmail.resend")}
              onClick={handleResendEmailClick}
              className="text-base font-normal text-neutral-darkest underline hover:text-primary-dark"
            />
          </div>
          <Button
            variant="primary"
            label={t("auth.common.backToHome")}
            color="primary-medium"
            hoverColor="primary-dark"
            textColor="white"
            onClick={handleBackButtonClick}
            size="sm"
            stretch
          />
        </div>
      </div>
    </div>
  );
};
